import useUploadForm from 'app/hooks/useUploadForm';

import {
  JOB_QRCODE_TEMPLATE_UPLOAD_URL
} from 'app/utils/Constants';

import {
  updateJob
} from 'app/services/jobs';

const useQrCodeTemplateUploadForm = props => {
  const {
    job,
    onUploadStart,
    onUploadComplete
  } = props;

  const createFileContexts = async params => {
    // the original file objects shouldn't be altered
    const file = params.files[0];

    let fileContexts = [{
      id: job.id + '-qrcodetemplate',
      uploadUrlEndpoint: JOB_QRCODE_TEMPLATE_UPLOAD_URL(job.id, file.type)
    }]

    if (onUploadStart) {
      onUploadStart(file);
    }

    return fileContexts;
  }

  const onFileComplete = async () => {
    await updateJob(job.id, { has_qr_template: true });

    if (onUploadComplete) {
      onUploadComplete();
    }
  }

  const {
    formIsOpen,
    onFormClose,
    onFormSubmit,
    onAdd,
  } = useUploadForm({
    createFileContexts,
    onFileComplete
  });

  return {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  }
}

export default useQrCodeTemplateUploadForm;
